import { getCookie } from '../utils';

const languages = ['en', 'ru'];
const defaultLanguage = getCookie('Exadel.EIS.Language') || languages[0];

const initialState = {
    currentLanguage: defaultLanguage,
};

export const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LANGUAGE':
            return { ...state, currentLanguage: action.payload };
        default:
            return state;
    }
};

export const setLanguage = language => ({
    type: 'SET_LANGUAGE',
    payload: language,
});
